import { DepartmentApi } from "../Api";
import { getAuthConfiguration } from "./configuration";

const ApiFactory = () => new DepartmentApi(getAuthConfiguration());

export const getAllDepartmentsForFaculty = (facultyId: string) => {
    return ApiFactory().apiDepartmentGetAllForFacultiesGet({ faculties: [facultyId] });
}